import { AuthConfig } from 'angular-oauth2-oidc';

export const authConfig: AuthConfig = {
  issuer: 'https://cbsi.okta.com',
  redirectUri: window.location.origin,
  clientId: '0oa1iyhrvyeKlVn1O1d8',
  //responseType: 'code',
   responseType: 'id_token token',
   scope: 'openid email profile groups',//offline_access
  
};
